export const REQUEST_PROFILE_TAB_ACTIVITIES_SKELETON_COLLAPSED_PHASES_COUNT = 2

export const REQUEST_PROFILE_TAB_ACTIVITIES_SKELETON_TABLE_ROWS_COUNT = 5

export const REQUEST_PROFILE_TAB_ACTIVITIES_SKELETON_TABLE_ROW_TITLE_WIDTHS = [
  '88%',
  '72%',
  '94%',
  '65%',
  '80%',
]
